export default __webpack_public_path__ + "./ico-catalogue-on.195f1b5597c173bba09b6e148d0d8ffd.png";